import { WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';
const _axios = HttpService.getAxiosClient();

export const applyWFH = async (wfhPayload) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/leaves/application/saveProcess`,
      wfhPayload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const approveWfhTask = async (task) => {
  try {
    const response = await _axios.put(`${WORKFLOW_PATH}/wfh/tasks`, task);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response);
  }
};
export const updateLeave = async (wfhPayload) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/leaves/application/updateProcess`,
      wfhPayload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const addWFHTask = async (payload) => {
  try {
    const response = await _axios.post(`${WORKFLOW_PATH}/wfh/tasks`, payload);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
export const getWFHTask = async (employeeId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/wfh/tasks/users/${employeeId}`,
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
export const getWfhTaskForManager = async (userId, wfhId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/wfh/tasks/manager/${userId}`,
      {
        params: { applicationId: wfhId },
      },
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getAllWfhTasks = async (wfhId, empId) => {
  try {
    const response = await _axios.get(`${WORKFLOW_PATH}/wfh/tasks`, {
      params: { applicationId: wfhId, empId: empId },
    });
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const deleteWFHTask = async (taskId, employeeId, wfhId) => {
  try {
    const response = await _axios.delete(
      `${WORKFLOW_PATH}/wfh/tasks/${taskId}/user/${employeeId}?${
        wfhId ? 'applicationId=' + wfhId : ''
      }`,
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getExceededWFHHours = async (
  empId,
  tenantId,
  requestedWfhHours,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/wfh/tasks/exceededhrs`,
      {
        params: {
          empId,
          tenantId,
          requestedWfhHours,
        },
      },
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserWFH = async (
  userId,
  type,
  pageSize,
  pageNumber,
  filterData,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application?${
        type ? 'type=' + type + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber + '&' : ''
      }${filterData.wfhStatus ? 'status=' + filterData.wfhStatus : ''}${
        filterData.startDate ? '&startDate=' + filterData.startDate : ''
      }${filterData.endDate ? '&endDate=' + filterData.endDate : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/** Task-relevant single-application fetch (reuses existing Workflow route with applicationId). */
export const getWFHApplicationById = async (userId, applicationId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application`,
      {
        params: {
          applicationId,
          type: 'WFH',
        },
      },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
